<script setup lang="ts">
import type { ProductLabel } from '~/types/misc'

const props = defineProps<{
  label: ProductLabel
}>()

const dialog = useUiDialog(`tooltip__${props.label.slug}`)
</script>

<template>
  <button
    type="button"
    class="product-label__tooltip-button label label--marketing"
    :style="label.style"
    @click="dialog.open()"
  >
    {{ label.label }}
  </button>
  <Teleport
    defer
    to="#teleports"
  >
    <LazyUiDialog
      :name="`tooltip__${label.slug}`"
      dialog-type="responsive"
    >
      <template #dialogHeader>
        {{ $t(label.label) }}
      </template>

      <StrapiBlocksText
        v-if="label.tooltip"
        :nodes="label.tooltip"
      />
    </LazyUiDialog>
  </Teleport>
</template>
